<template>
    <div class="tab-pane fade show active position-relative" id="activity">
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <product-pending-projects :productDetails="productDetails" class="pt-3"></product-pending-projects>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductPendingProjects from "./product-pending-projects.vue";
export default {
    name: "product-details-projects",
    components: {
        "product-pending-projects": ProductPendingProjects
    },
    props: {
        productDetails: Object
    },
    data() {
        return {
            loading: false
        };
    },
    mounted() {},
    methods: {}
};
</script>

<style lang="scss" scoped>
</style>
